<template>
  <div id="footer">
    <div id="infoot">
      <div class="top-foot">
        <div class="foot-logo">
          <a href="/" target="_self"
            ><img src="~@/assets/images/logo_foot.png"
          /></a>
        </div>
        <ul class="friend-link">
          <li v-for="item in links">
            <a :href="item.url" target="_blank" rel="noopener noreferrer">{{
              item.name
            }}</a>
          </li>
        </ul>
        <div style="padding-top: 10px">
          <img src="~@/assets/images/erweima.jpg" style="width: 100px" />
          <div>协会微信公众号</div>
        </div>
      </div>
      Copyright&nbsp;&nbsp;©&nbsp;&nbsp;
      2025&nbsp;&nbsp;www.tjchxh.org.cn&nbsp;&nbsp;All&nbsp;&nbsp;Rights&nbsp;&nbsp;Reserved.&nbsp;&nbsp;&nbsp;&nbsp;<a
        href="http://beian.miit.gov.cn/"
        target="_blank"
        se_prerender_url="complete"
        >津ICP备19001453号-1</a
      ><br />
      版权所有&nbsp;&nbsp;天津市测绘与地理信息协会&nbsp;&nbsp;&nbsp;&nbsp;地址：天津市西青区李七庄昌凌路9号（300381）&nbsp;&nbsp;E-Mail:
      tjchxh712@126.com
    </div>
  </div>
</template>
<script setup>
const links = [
  { name: "自然资源部", url: "https://www.mnr.gov.cn/" },
  { name: "中国地理信息产业协会", url: "https://www.cagis.org.cn/" },
  { name: "天津市民政局", url: "https://mz.tj.gov.cn/" },
  { name: "天津市规划和自然资源局", url: "https://ghhzrzy.tj.gov.cn/" },
  {
    name: "天津市社会组织公共服务平台",
    url: "https://mz.tj.gov.cn/tjsmzjjzc/TJSHZZGGFWPT8299/",
  },
];
</script>
<style lang="scss">
.top-foot {
  display: flex;
  justify-content: space-around;
  .foot-logo {
    img {
      width: 300px;
    }
  }
  .friend-link {
    width: 500px;
    padding-top: 10px;
    li {
      float: left;
      padding: 4px 12px;
      background-color: #fff;
      margin-right: 8px;
      margin-bottom: 8px;
      border-radius: 8px;
      a {
        color: #000;
        &:hover {
          color: #006dad;
        }
      }
    }
  }
}
</style>
